<template>
	<div class="message">
		<nav-bar navBarTitle="我的消息"></nav-bar>
		<div class="message-content">
			<van-list
				v-model="loading"
				:finished="finished"
				@load="onLoad"
				:finished-text="finishedText"
			>
				<div class="message-content-item" v-for="(item, index) in messageList" :key="index" @click="goDetail(item)">
					<div class="message-content-item-l">
						<img :src="messageTypeObj[item.messageType].logoSrc" alt="">
						<div :class="{'read-flag': !item.isRead}"></div>
					</div>
					<div class="message-content-item-c">
						<h2>{{ item.title }}</h2>
						<p class="content">{{ item.content }}</p>
						<p class="time">{{ item.sendTime | sendTimeStr | timeSub }}</p>
					</div>
					<div class="message-content-item-r">
						<span class="icon iconfont iconfanhui2"></span>
					</div>
					<img class="close" src="../../assets/img/member/close.png"  v-if="isEdit" @click.stop="showTips(item.messageLogId)" />
				</div>
			</van-list>
		</div>
		<list-operate  v-if="dataList.length" @handleEdit="isEdit = true" @handleDone="isEdit = false" @handleClear="clearList"></list-operate>
		<!-- 消息详情展示 -->
		<van-popup
			v-model="showPopDetail"
			closeable
			round
			@closed="changeReadStatus"
			close-icon-position="top-right"
			position="bottom"
			:style="{ height: '90%' }"
		>
			<div class="popup-message">
				<div  class="message-wrap">
					<div class="message-title">
						{{ messageDetailObj.title }}
					</div>
					<div class="message-content">{{ messageDetailObj.content }}</div>
					<div class="message-time">{{ messageDetailObj.sendTime | sendTimeStr}}</div>
					<div  class="message-btn" @click="changePage(messageDetailObj)">{{ messageDetailObj.toButtonName}}</div>
				</div>
			</div>
		</van-popup>
		<!--没有数据-->
		<no-data v-if="!dataList.length" :type="1"></no-data>
		<system-confirm text="确认删除？" :show.sync="deleteShow" @handleConfirm="deleteData" @handleCancel="handleCancel"></system-confirm>
	</div>
</template>

<script>
	import ListOperate from '../../components/ListOperate'
	import NoData from '../../components/NoData'
	import SystemConfirm from '../../components/SystemConfirm'
	import { extend, formatDate, isEmpty, isEmptyObject } from '../../utils';
	import {messageTypeObj} from '../../utils/const'
	// import { Toast } from 'vant';
	import { reqClearMsgList, reqDeleteMsg, reqMsgDetail, reqMsgList } from '../../api';
	import moment from 'moment'
	import { mapActions, mapGetters, mapMutations } from 'vuex';

	export default {
		name: 'message',
		components: {
			ListOperate,
			SystemConfirm,
			NoData
		},
		data() {
			return {
				messageTypeObj,
				userId: localStorage.getItem('userId'),
				dataList: [],
				page: 1,
				size: 10,
				loading: false,
				finished: false,
				messageDetailObj: {
					title: '',
					content: '',
					messageType: null, // 消息类型
					sendTime: '', //发送时间
					type: null,
					toButtonName: '', // 跳转名称
					toPageType: null, // 跳转页面按钮
					logoSrc: require('../../assets/img/member/msg_icon1.png'),
					messageDetailsInput: {},  // 跳转页面参数
					messageLogId: 0,
				},
				toPageTypeObj: {
					3: '/vip/vipfree', // 赠送vip页面
					4: '/home', //首页
					5: '/member', // 我的个人中心
					6: '/vip/vipjoin', // vip订购页
					7: '/member/coupon' // 我的优惠券
				},
				isEdit: false, // 是否是编辑状态
				showPopDetail: false, // 消息详情弹窗
				deleteShow: false,
				deleteMessageId: null, // 删除消息当前id
			}
		},
		created() {
			this.getDataList()
		},
		computed: {
			...mapGetters(['messageList']),
			finishedText: {
				get(){
					return this.finished === true&& this.dataList.length!==0 ? '没有更多了' : ''
				},
				set(){
				}
			},
		},
		filters: {
			sendTimeStr: function (value) {
				let str  = formatDate(value,'yyyy.MM.dd HH:mm:ss')
				let time = str.replace(/\./g, '/')
				let today = moment();
				let yesterday = moment().subtract(1, 'day');
				if(moment(time).isSame(today, 'day')){
					return   `今天 ${str.substr(11,5)}`
				} else if(moment(time).isSame(yesterday, 'day')){
					return   `昨天 ${str.substr(11,5)}`
				} else {
					return `${str.substr(0,16)}`
				}
			},
			timeSub:function (value) {
				return `${value.substr(0,10)}`
			}
		},
		watch:{
			dataList(newList) {
				if(newList.length){
					this.dataList = newList
				}
			}
		},
		methods: {
			...mapActions({'changeMsgRead': 'changeMsgList'}),
			...mapMutations({
				'setMessageList': 'SET_MESSAGELIST'
			}),
			// 查看详情改变状态
			changeReadStatus() {
				this.changeMsgRead(this.messageDetailObj.messageLogId)
			},
			// 列表加载
			onLoad() {
				this.page++
				this.getDataList()
			},
			// 获取消息列表
			getDataList() {
				this.loading = true
				let params = {
					userId: this.userId,
					page: this.page,
					size: this.size,
				}
				reqMsgList(params).then(res=>{
					// 加载状态结束
					this.loading = false;
					let list  = res.data || []
					if (list.length < this.size) {
						this.finished = true;
					}
					this.dataList = this.dataList.concat(list)
					this.setMessageList(this.dataList)

				})
			},
			// 跳转详情
			goDetail(item) {
				let params = {
					messageLogId: item.messageLogId || 0,
					userId: item.userId,
				}
				reqMsgDetail(params).then(res => {
					this.showPopDetail = true
					if(!isEmptyObject(res)){
						extend(this.messageDetailObj, res.data)
					}
				})
			},
			// 详情页面跳转
			changePage(item) {
				if(!isEmpty(item.toPageType)) {
					this.$router.push({path: this.toPageTypeObj[item.toPageType]})
				}
			},
			// 删除显示提示框
			showTips(id) {
				if(!isEmpty(id)){
					this.deleteMessageId = id
					this.deleteShow  = true
				}
			},
			// 清空所有数据
			clearList(){
				// 删除所有的数据
				reqClearMsgList({userId: this.userId}).then(()=> {
					// 页面刷新
					this.refresh()
				})
			},
			// 删除某条消息
			deleteData(){
				// 删除数据
				let params = {
					userId: this.userId,
					messageLogId: this.deleteMessageId
				}
				reqDeleteMsg(params).then(()=>{
					this.deleteMessageId = null
					this.refresh()
				})
			},
			// 取消删除
			handleCancel() {
				this.deleteMessageId  = null
			},
			// 刷新
			refresh(){
				this.page = 1
				this.dataList = []
				this.loading =  false
				this.finished  = false
				this.isEdit = false
				this.getDataList()
			}
		}
	};
</script>

<style lang="less" scoped>
	.message {
		padding: 16px 16px 0;
		&-content{
			width: 100%;
			margin-bottom: 20px;
			&-item {
				width: 100%;
				height: 120px;
				padding: 16px;
				display: flex;
				justify-content: center;
				align-items: center;
				box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
				border-radius:5px;
				position: relative;
				margin-top: 16px;
				&-l {
					width: 20px;
					height: 100%;
					position: relative;
					>img {
						width: 20px;
						height: 20px;
					}
					.read-flag {
						display: inline-block;
						width:6px;
						height:6px;
						background: #FA5151;
						border:1px solid #FFFFFF;
						border-radius: 50%;
						position: absolute;
						right: -3px;
						top: -3px;

					}
				}
				&-c {
					margin-left: 10px;
					flex:1;
					display: flex;
					flex-direction: column;
					height: 100%;
					h2 {
						font-weight: bold;
						line-height: 22px;
					}
					.content  {
						margin-top: 10px;
						font-size:12px;
						font-weight:400;
						color:@subBlack;
						line-height:17px;
					}
					p.content{
						overflow: hidden;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
					}
					.time {
						margin-top: 10px;
						font-size:12px;
						line-height: 12px;
						color: #999999;
					}
				}
				&-r {
					margin-left: 16px;
					color: @lightBlack;
					.iconfanhui2{
						font-size: 12px;
					}
				}
			}
		}
		.close {
			position: absolute;
			top: 0;
			right: 0;
			width: 24px;
			height: auto;
		}
		// 消息详情弹窗
		.popup-message {
			width: 100%;
			height: 100%;
			position: relative;
			padding: 60px 20px 0;
			.message-wrap {
				width: 100%;
				.message-title {
					height:18px;
					font-size:18px;
					font-weight:500;
					color:@darkBlack;
					line-height:18px;
					text-align: center;
				}
				.message-content {
					font-size:14px;
					font-weight:400;
					color:@darkBlack;
					line-height:24px;
					margin-top: 40px;
				}
				.message-time {
					font-size: 12px;
					font-weight:400;
					color:@lightBlack;
					line-height:12px;
					margin-top: 20px;
				}
				.message-btn {
					position: absolute;
					bottom: 38px;
					width: 335px;
					height: 40px;
					border-radius:5px;
					border:0.5px solid #DDDDDD;
					font-size: 16px;
					color: @darkBlack;
					background: none;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}

</style>
